import styles from "./HeaderButton.module.css";
import type { ButtonProps, PolymorphicFactory } from "@mantine/core";
import { Button, polymorphicFactory } from "@mantine/core";
import type { ComponentPropsWithoutRef } from "react";

type HeaderButtonProps = ButtonProps & ComponentPropsWithoutRef<"button">;

type HeaderButtonFactory = PolymorphicFactory<{
  props: HeaderButtonProps;
  defaultComponent: "button";
  defaultRef: HTMLButtonElement;
}>;

const HeaderButton = polymorphicFactory<HeaderButtonFactory>(({ ref, ...props }) => {
  return (
    <Button
      classNames={{ root: styles.root, section: styles.section }}
      ref={ref}
      color="gray"
      variant="subtle"
      size="sm"
      px={8}
      td="none"
      miw="unset"
      fw={500}
      {...props}
    />
  );
});

export default HeaderButton;
